// 表单数据
export const formData = {
  adName: '',
  areaId: '',
  positionId: '',
  picture: '',
  pictureAlt: '',
  houseId: '',
  startTime: '',
  endTime: '',
  sortIndex: '',
  isHot: true,
  isRecommend: true,
};

// 表单验证规则
export const formRules = {
  adName: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  areaId: [{ required: true, message: '城市不能为空', trigger: 'blur' }],
  positionId: [
    { required: true, message: '广告位置不能为空', trigger: 'blur' },
  ],
  picture: [{ required: true, message: '广告图不能为空', trigger: 'blur' }],
  pictureAlt: [
    { required: true, message: '广告图标签不能为空', trigger: 'blur' },
  ],
  adType: [{ required: true, message: '广告类型不能为空', trigger: 'blur' }],
  houseId: [{ required: false, message: '广告链接不能为空', trigger: 'blur' }],
  //   href: [{ required: true, message: ' 链接不能为空', trigger: 'blur' }],
  startTime: [{ required: true, message: '开始时间不能为空', trigger: 'blur' }],
  endTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
  sortIndex: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
};
